<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <NavBar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    NavBar,
    Footer
  }
};
</script>

<style>
#app {
  font-family: Nunito;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#main-container {
  min-height: 100vh;
}

a:link {
  text-decoration: none;
}

body {
  margin: 0px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.bg-blue {
  background-color: #d6e5ed;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.column {
  flex-direction: column;
}

.row {
  flex-direction: row;
}

.big-box {
  width: 100%;
}

.max-width {
  width: 100%;
}

.max-height {
  height: 100%;
}

.title {
  font-size: 60px;
  font-weight: 900;
}

.sub-title {
  font-size: 38px;
  font-weight: 800;
}

.body {
  font-size: 24px;
  font-weight: 500;
}

.bm-menu {
  background-color: #ffd169 !important ;
}

.bm-burger-button {
  height: 25px;
  width: 34px;
  top: 25px;
}

@media screen and (max-width: 600px) {
  .title {
    font-size: 30px;
  }

  .sub-title {
    font-size: 22px;
  }

  .body {
    font-size: 14px;
  }
}

@media screen and (max-width: 320px) {
  .title {
    font-size: 25px;
  }

  .sub-title {
    font-size: 18px;
  }

  .body {
    font-size: 12px;
  }
}
</style>
